export default __webpack_public_path__ + "static/media/il-logo.cb45a14c.png";